import * as types from '../../mutation-types'
import * as api from '../../api'
import router from '../../../router'

const state = {
  banned_ip: {},
  ignored_ips: [],
  console_command_result: '',
  network_interfaces: [],
  network_interfaces_received_timestamp: new Date(0),
  dns_servers: [],
  dns_servers_received_timestamp: new Date(0),
  time_zones: [],
  time_zones_received_timestamp: new Date(0),
  current_time_zone: '',
  time_servers: [],
  time_servers_received_timestamp: new Date(0),
  host_name: '',
  storages: [],
  storages_received_timestamp: new Date(0)
}

const getters = {
  bannedIp: state => state.banned_ip,
  allIgnoredIps: state => state.ignored_ips,
  consoleCommandResult: state => state.console_command_result,
  allNetworkInterfaces: state => state.network_interfaces,
  allDNSServers: state => state.dns_servers,
  currentTimeZone: state => state.current_time_zone,
  allTimeZones: state => state.time_zones,
  allTimeServers: state => state.time_servers,
  hostName: state => state.host_name,
  allStorages: state => state.storages
}

const actions = {
  executeConsoleCommand ({ commit }, command) {
    switch (command) {
      case 'power off':
        alert('ALERT: Machine powering off, you will need to physically turn it back on. You will have NO access to the machine until it had been physically restarted.')
        break
      case 'reboot':
        alert('ALERT: Machine rebooting, your current session will continue but you will be limited in what you can do until the machine is back online.')
        break
    }

    let dataToSend = {
      command: command
    }
    api.instance.post('console_command', dataToSend)
      .then(function (response) {
        let result = response.data.result
        commit(types.RECEIVE_COMMAND_RESULT, result)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getNetworkInterfaces ({ commit }) {
    const diff = Math.abs(new Date(state.network_interfaces_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('network_interfaces')
        .then(function (response) {
          const networkInterfaces = response.data.network_interfaces
          commit(types.RECEIVE_NETWORK_INTERFACES, networkInterfaces)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  saveNetworkInterfaces ({ commit }, networkInterfaces) {
    api.instance.put('network_interfaces', networkInterfaces)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.SAVE_NETWORK_INTERFACES, networkInterfaces)
          router.push({ name: 'AdminMachineNetwork' })
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getDNSServers ({ commit }) {
    const diff = Math.abs(new Date(state.dns_servers_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('dns_servers')
        .then(function (response) {
          const dnsServers = response.data.dns_servers
          commit(types.RECEIVE_DNS_SERVERS, dnsServers)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addDNSServer ({ commit }, dnsServer) {
    if (dnsServer.address !== '') {
      api.instance.post('dns_servers', dnsServer)
        .then(function (response) {
          if (response.data.success === 'true') {
            const dnsServer = response.data.dns_server[0]
            commit(types.ADD_DNS_SERVER, dnsServer)
            router.push({ name: 'AdminMachineDNSIndex' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteDNSServer ({ commit }, dnsServer) {
    api.instance.delete('dns_servers/' + dnsServer.dns_server_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_DNS_SERVER, dnsServer)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getTimeZones ({ commit }) {
    const diff = Math.abs(new Date(state.time_zones_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('time_zones')
        .then(function (response) {
          const timeZones = response.data.time_zones
          commit(types.RECEIVE_TIME_ZONES, timeZones)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getCurrentTimeZone ({ commit }) {
    api.instance.get('current_time_zone')
      .then(function (response) {
        const currentTimeZone = response.data.current_time_zone
        commit(types.RECEIVE_CURRENT_TIME_ZONE, currentTimeZone)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  setCurrentTimeZone ({ commit }, timeZone) {
    if (timeZone !== '0') {
      api.instance.put('current_time_zone', { 'current_time_zone': timeZone })
        .then(function (response) {
          if (response.data.success === 'true') {
            commit(types.SET_CURRENT_TIME_ZONE, timeZone)
            router.go('/admin/machine/time_zone')
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      alert('Please choose a Time Zone.')
    }
  },
  getTimeServers ({ commit }) {
    const diff = Math.abs(new Date(state.time_servers_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('time_servers')
        .then(function (response) {
          const timeServers = response.data.time_servers
          commit(types.RECEIVE_TIME_SERVERS, timeServers)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addTimeServer ({ commit }, timeServer) {
    if (timeServer.address !== '') {
      api.instance.post('time_servers', timeServer)
        .then(function (response) {
          if (response.data.success === 'true') {
            const timeServer = response.data.time_server[0]
            commit(types.ADD_TIME_SERVER, timeServer)
            router.push({ name: 'AdminMachineTimeServerIndex' })
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteTimeServer ({ commit }, timeServer) {
    api.instance.delete('time_servers/' + timeServer.time_server_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          commit(types.DELETE_TIME_SERVER, timeServer)
        } else {
          alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getHostName ({ commit }) {
    api.instance.get('host_name')
      .then(function (response) {
        const hostName = response.data.host_name
        commit(types.RECEIVE_HOST_NAME, hostName)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  uploadUpdateFile ({ commit }, update) {
    let formData = new FormData()
    formData.append('update_file', update.file)

    api.instance.post('update_server', formData, { 'content-type': 'multipart/form-data' })
      .then(response => {
        if (!response.data.success) {
          update.onUploadFail(response)
        }

        update.onUploadSuccess(response)
      }).catch(error => {
        update.onUploadFail(error)
      })
  },
  setHostName ({ commit }, hostName) {
    if (hostName !== '') {
      api.instance.put('host_name', { 'host_name': hostName })
        .then(function (response) {
          if (response.data.success === 'true') {
            commit(types.SET_HOST_NAME, hostName)
            alert(response.data.message)
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      alert('Please enter a valid host name.')
    }
  },
  getStorages ({ commit }) {
    const diff = Math.abs(new Date(state.storages_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('storages')
        .then(function (response) {
          const storages = response.data.machine_storages
          commit(types.RECEIVE_STORAGES, storages)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  toggleNTPServer ({ commit }, status) {
    api.instance.put('ntp_server/' + status)
      .then(function (response) {
        if (response.data.success === 'true') {
          alert(response.data.message)
        } else {
          alert(response.data.message)
        }
      })
  },
  getBannedIp ({ commit }, ip) {
    api.instance.get('firewall/banned_ip/' + ip)
      .then(function (response) {
        commit(types.RECEIVE_BANNED_IP, { ip: ip, is_banned: response.data.is_banned })
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  clearBannedIp ({ commit }) {
    commit(types.RECEIVE_BANNED_IP, {})
  },
  banIp ({ commit, getters }) {
    api.instance.put('firewall/banned_ip/' + getters.bannedIp.ip)
      .then(function (response) {
        alert(response.data.message)
        commit(types.BAN_IP)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  unBanIp ({ commit, getters }) {
    api.instance.delete('firewall/banned_ip/' + getters.bannedIp.ip)
      .then(function (response) {
        alert(response.data.message)
        commit(types.UNBAN_IP)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getIgnoredIps ({ commit }) {
    api.instance.get('firewall/ignored_ips')
      .then(function (response) {
        commit(types.RECEIVE_IGNORED_IPS, response.data.ignored_ips)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  ignoreIp ({ commit }, ip) {
    api.instance.put('firewall/ignored_ips/' + ip)
      .then(function (response) {
        alert(response.data.message)
        commit(types.IGNORE_IP, ip)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  unIgnoreIp ({ commit }, ip) {
    api.instance.delete('firewall/ignored_ips/' + ip)
      .then(function (response) {
        alert(response.data.message)
        commit(types.UNIGNORE_IP, ip)
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const mutations = {
  [types.RECEIVE_CONSOLE_COMMAND_RESULT] (state, result) {
    state.console_command_result = result
  },
  [types.RECEIVE_NETWORK_INTERFACES] (state, networkInterfaces) {
    state.network_interfaces = networkInterfaces
    state.dns_servers_received_timestamp = Date.now()
  },
  [types.SAVE_NETWORK_INTERFACES] (state, networkInterfaces) {
    alert('Successfully saved! Please restart the machine for the changes to take effect.')
    state.network_interfaces = networkInterfaces
  },
  [types.RECEIVE_DNS_SERVERS] (state, dnsServers) {
    state.dns_servers = dnsServers
    state.dns_servers_received_timestamp = Date.now()
  },
  [types.ADD_DNS_SERVER] (state, dnsServer) {
    state.dns_servers.push(dnsServer)
  },
  [types.DELETE_DNS_SERVER] (state, dnsServer) {
    let dnsServerToDelete = state.dns_servers.find(
      function (ele) {
        if (ele.dns_server_id === dnsServer.dns_server_id) {
          return true
        }
      }
    )
    let index = state.dns_servers.indexOf(dnsServerToDelete)
    state.dns_servers.splice(index, 1)
  },
  [types.RECEIVE_TIME_ZONES] (state, timeZones) {
    state.time_zones = timeZones
    state.time_zones_received_timestamp = Date.now()
  },
  [types.RECEIVE_CURRENT_TIME_ZONE] (state, currentTimeZone) {
    state.current_time_zone = currentTimeZone
  },
  [types.SET_CURRENT_TIME_ZONE] (state, currentTimeZone) {
    state.current_time_zone = currentTimeZone
  },
  [types.RECEIVE_TIME_SERVERS] (state, timeServers) {
    state.time_servers = timeServers
    state.time_servers_received_timestamp = Date.now()
  },
  [types.ADD_TIME_SERVER] (state, timeServer) {
    state.time_servers.push(timeServer)
  },
  [types.DELETE_TIME_SERVER] (state, timeServer) {
    let timeServerToDelete = state.time_servers.find(
      function (ele) {
        if (ele.time_server_id === timeServer.time_server_id) {
          return true
        }
      }
    )
    let index = state.time_servers.indexOf(timeServerToDelete)
    state.time_servers.splice(index, 1)
  },
  [types.RECEIVE_HOST_NAME] (state, hostName) {
    state.host_name = hostName
  },
  [types.SET_HOST_NAME] (state, hostName) {
    state.host_name = hostName
  },
  [types.RECEIVE_STORAGES] (state, storages) {
    state.storages = storages
    state.storages_received_timestamp = Date.now()
  },
  [types.RECEIVE_BANNED_IP] (state, bannedIp) {
    state.banned_ip = bannedIp
  },
  [types.BAN_IP] (state) {
    state.banned_ip.is_banned = true
  },
  [types.UNBAN_IP] (state) {
    state.banned_ip.is_banned = false
  },
  [types.RECEIVE_IGNORED_IPS] (state, ignoredIps) {
    state.ignored_ips = ignoredIps
  },
  [types.IGNORE_IP] (state, ip) {
    if (!state.ignored_ips.includes(ip)) {
      state.ignored_ips.push(ip)
    }
  },
  [types.UNIGNORE_IP] (state, ip) {
    let ipToRemove = state.ignored_ips.find(
      function (ele) {
        if (ele === ip) {
          return true
        }
      }
    )
    let index = state.ignored_ips.indexOf(ipToRemove)
    state.ignored_ips.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
